import {FC} from 'react'

import {getPricingContent} from '@/content/pricing'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {AnalyticsTrackedEvent} from '@/utils/tracking/types'

import {PricingCounterField} from './PricingCounterField'

type PricingTrademarksSelectProps = {
  selectedTrademarks: number
  setSelectedTrademarks: (selectedTrademarks: number) => void
  minSelectedTrademarks: number
  trackedEvent: AnalyticsTrackedEvent
}

export const PricingTrademarksSelect: FC<PricingTrademarksSelectProps> = ({
  selectedTrademarks,
  setSelectedTrademarks,
  minSelectedTrademarks,
  trackedEvent,
}) => {
  const {t} = useTranslation()
  const {numOfTrademarksTitle} = getPricingContent().calculator

  return (
    <PricingCounterField
      title={{text: t(numOfTrademarksTitle), color: theme.palette.text.light}}
      value={selectedTrademarks}
      setValue={setSelectedTrademarks}
      minValue={minSelectedTrademarks}
      trackedEvent={trackedEvent}
    />
  )
}
